import UIComponent from "../ui/component.js";
import api from "../api/index.js";
import goals from "../utils/goals.js";

export class DownloadFromClipboard extends UIComponent {
    init() {
        this.api = this.attr("data-api");

        this.on('click', this.handleClick.bind(this));
    }

    async getClipboardContent() {
        try {
            return await navigator.clipboard.readText();
        } catch(err) {
            console.error('The clipboard is not supported');
            console.error(err);
            return null;
        }
    }

    async handleClick() {
        const link = await this.getClipboardContent();
        if (!link) return;

        this.startUploadByLink(link);
    }

    onSuccess(file) {}

    onError(error) {}

    startUploadByLink(link) {
        if (!this.api) return;

        goals.reach("startFileUploadLink");

        // this.notification.show();

        api.post(this.api, { link })
            .then((data) => {
                if (data.throwable_error) {
                    this.onError(data.throwable_error);
                } else {
                    this.onSuccess({ ...data[0] });
                }
            })
            .catch((error) => this.onError(error));
    }
}
